import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@faerdo/api';

export const trpc = createTRPCReact<AppRouter>();
